<template>
	<div>
		<img src="../../../public/pic/aftersale/aftersale.png" />
		<br /><br /><br />
		<div style="width: 90%;text-align: left;" class="center_sun">
			<h2>
				<i class="el-icon-user-solid">{{ $t('lang.Sold1')}}</i>
			</h2>
			<hr style="margin-top: 10px;" />
			<h2>{{ $t('lang.Sold2')}}</h2>
			<p>{{ $t('lang.Sold3')}}</p>
			<p>{{ $t('lang.Sold4')}}</p>
			<p>{{ $t('lang.Sold5')}}</p>
			<p>{{ $t('lang.Sold6')}}</p>
			<p>{{ $t('lang.Sold7')}}</p>
			<br /><br /><br />
			<h2>{{ $t('lang.Sold8')}}</h2>
			<p>{{ $t('lang.Sold9')}}</p>
			<br /><br /><br />
			<h2>{{ $t('lang.Sold10')}}</h2>
			<p>{{ $t('lang.Sold11')}}</p>
			<p>{{ $t('lang.Sold12')}}</p>
			<p>{{ $t('lang.Sold13')}}</p>
			<p>{{ $t('lang.Sold14')}}</p>
			
		</div>
	</div>
</template>

<script>
export default {
	head(){
		return {
			title : '售后服务_深圳全智能机器人科技有限公司。After-Sale-Service_Shenzhen All Intelligent Technology Co., Ltd.',
			keywords : '消毒机器人,迎宾机器人，陪护机器人,送餐机器人,硅胶实体娃娃,深圳全智能机器人科技有限公司。Disinfection Robot,Reception Robot,Companion Robot,Delivery Robot,Silicone Dolls,Shenzhen All Intelligent Technology Co., Ltd.',
			description : '全智能科技（AI-Tech）是深圳全智能机器人科技有限公司[Shenzhen All Intelligent Technology Co.，Ltd. ]的简称，沿革于2013年，创建于2016年8月18日。顾名思义，全智能科技（AI-Tech）是以研发、生产、销售人工智能技术服务和产品的国家级高新技术企业。我们利用自主开发的核心技术，以“虚实结合、软硬兼备”的模式，致力于打造实用型的新型人工智能技术和AI科技共享平台。  AI-Tech short for Shenzhen All Intelligent Technology Co.，Ltd. started in 2013 which is a national level high tech company researching, manufacturing, selling AI services and AI products. We leverage self-developed core technologies,combine services with products,software with hardware, dedicating to creat a sharable platform of new pratical AI technology.',
			};
	},
}
</script>

<style scoped>
	p{
		font-size: 15px;
		text-align: justify;/*外部引人入的不生效*/
	}
</style>
